import { render, staticRenderFns } from "./FastTrackAllowance.vue?vue&type=template&id=50e7a9d6&"
import script from "./FastTrackAllowance.vue?vue&type=script&lang=js&"
export * from "./FastTrackAllowance.vue?vue&type=script&lang=js&"
import style0 from "./FastTrackAllowance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports